import { Link } from "react-router-dom";
import { ChevronDown, Sparkles } from "lucide-react";
import { GUIDES } from "@/lib/guides";

const [featured, ...rest] = GUIDES;

/** Desktop "Guides" dropdown in the header. */
export const GuidesMenu = ({ light }) => (
  <div className="group relative" data-testid="nav-guides">
    <button type="button" className={`flex items-center gap-1 text-[15px] transition-opacity hover:opacity-70 ${light ? "text-white" : "text-ink"}`} data-testid="nav-guides-button" aria-haspopup="true">
      Guides <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover:rotate-180 group-focus-within:rotate-180" />
    </button>
    <div className="invisible absolute left-1/2 top-full z-50 w-[380px] -translate-x-1/2 pt-4 opacity-0 transition-[opacity,visibility] duration-200 group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100">
      <ul className="rounded-md border border-neutral-200 bg-white p-3 text-ink shadow-[0_24px_60px_-20px_rgba(0,0,0,0.4)]" data-testid="guides-menu">
        <li className="mb-2">
          <Link to={`/guides/${featured.slug}`} data-testid={`guides-link-${featured.slug}`} className="block rounded bg-ink px-4 py-3 text-white transition-colors hover:bg-neutral-800">
            <span className="flex items-center gap-2 text-[15px] font-medium"><Sparkles className="h-4 w-4 text-brass" /> {featured.nav}</span>
            <span className="mt-0.5 block text-[12.5px] text-white/75">Instant estimate in 60 seconds, free</span>
          </Link>
        </li>
        {rest.map((g) => (
          <li key={g.slug}>
            <Link to={`/guides/${g.slug}`} data-testid={`guides-link-${g.slug}`} className="block rounded px-3 py-2 transition-colors hover:bg-neutral-100">
              <span className="block text-[15px]">{g.nav}</span>
              <span className="block text-[12.5px] text-neutral-500">{g.tile}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

/** Phone/tablet menu version. */
export const GuidesList = ({ onPick }) => (
  <ul className="space-y-0.5 py-2" data-testid="mobile-guides-list">
    {GUIDES.map((g) => (
      <li key={g.slug}>
        <Link to={`/guides/${g.slug}`} onClick={onPick} data-testid={`mobile-guides-${g.slug}`}
          className={`block py-1.5 text-[15px] ${g === featured ? "font-medium text-brass-deep" : "text-ink"}`}>{g === featured ? `${g.nav} (free estimate)` : g.nav}</Link>
      </li>
    ))}
  </ul>
);
